import { createApp } from 'vue'
import { createSticky } from './assets/stickyTableHeader'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/zh-cn';
import './theme.scss';

import router from './router'
import App from './App.vue'

const app = createApp(App).use(ElementPlus, { locale }).use(router)

createSticky(app)

app.mount('#app')
